module.exports = __webpack_public_path__ + "static/media/incident_category-ground_transportation.50839009.svg";